var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnect4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 128,
    viewBox: "0 0 527.8 128.2",
    width: 528,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#2e4369"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M522.1,56.8c0-30-20.9-51.1-50.2-51.1c-37.3,0-62.3,27.1-62.3,65.8c0,30.2,21.1,51.1,50.9,51.1 c27.1,0,47.3-13.1,55.6-34H486c-4,6.5-12.5,10.6-22.9,10.6c-16,0-26-10.6-26.9-25.6h84.2C521.5,67.9,522.1,63,522.1,56.8z M438.5,53.3c2.7-13.8,16.1-24.8,32.3-24.8c14,0,24.6,10.2,24.6,24.8H438.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.7,119.9l5.4-28.8c16.5,3.3,19-6,23.3-28.4l2.1-11.1c6-31.3,18.1-46.9,52.7-42.7l-5.4,28.8 c-16.5-3.3-19.4,9.2-23.1,28.6l-2.1,11.1C375.6,109.1,363.1,124.1,328.7,119.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3 120L308.7 8.4 335.6 8.4 315.3 120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2 8.4L160.3 8.4 168.8 89.1 203 8.4 228.9 8.4 238 89.9 271 8.4 297 8.4 249.7 120 220.1 120 210.5 43.2 177.8 120 149.2 120z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.7 38L5.7 67.6 58.4 67.6 63.9 54.7 37.2 54.7 53.9 38 44.2 21.3 89.5 21.3 47.7 120 63.4 120 110.7 8.4 19.3 8.4z",
    fill: "#00b9ff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect4);
export default __webpack_public_path__ + "static/media/connect4.5c8d14747eb40c9845c3f830d9f0ece5.svg";
export { ForwardRef as ReactComponent };